import React from "react";
import "../EventGallery.css";

const Daytwo2024 = () => {
  const images = [
    "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2024/day2-2024/1.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/2.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/3.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/4.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/5.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/6.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/7.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/8.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/9.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/10.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/11.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/12.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/13.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/14.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/15.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/16.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/17.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/18.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/19.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/20.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/21.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/22.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/23.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/24.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/25.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/26.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/27.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/28.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/29.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/30.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day2-2024/31.webp",
    
  ];

  return (
    <div className="event-gallery-container">
      <h2 className="event-gallery-title">Event 2024 Day 2</h2>
      <div className="event-gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="event-gallery-card">
            <img src={img} alt={`Event ${index + 1}`} />
          </div> 
        ))}
      </div>  
    </div>
  );
};

export default Daytwo2024;